import { CSSProperties, ReactNode } from 'react'

import {
  Text,
  Primary12SemiBold,
  GreyGrey60,
  Flex
} from '@sequencehq/core-components'
import { FieldValidationError } from './FieldValidationError'

type Props = {
  label: string
  textAlign?: CSSProperties['textAlign']
  validationErrors?: string[]
  children: ReactNode
}

export const FieldLabel = ({
  label,
  textAlign = 'left',
  validationErrors,
  children
}: Props) => (
  <Flex flex="1" flexDir="column" gap="8px">
    <Text {...Primary12SemiBold} color={GreyGrey60} textAlign={textAlign}>
      {label}
    </Text>
    {children}
    <FieldValidationError errors={validationErrors} />
  </Flex>
)
